module.exports = __webpack_public_path__ + "media/images/icons/country_flags/er-a45d00f89ad6af0a805d3c2603d8098e.svg";